export default (transaction) => ({
  amount: transaction.amount,
  paymentMethod: transaction.paymentMethod,
  walletNumber: transaction.walletNumber
});
